import { StyleSheet, Text, View } from 'react-native'
import React from 'react'

export const InformationCenter = () => {
  return (
    <View>
      <Text>InformationCenter</Text>
    </View>
  )
}


const styles = StyleSheet.create({})